import { UserLabel } from '@app/components/users/UserLabel';
import { webApi } from '@mi-front/api-clients';
import { Typography } from '@mui/material';

/**
 * Renders the fragment creator: user label and optional dot separator.
 * Renders nothing when fragment has no creator.
 */
export function FragmentCardCreator({
  creator,
}: {
  creator: webApi.FragmentListItemDto['creator'];
}) {
  if (!creator) return null;

  return (
    <>
      <Typography variant="caption" color="text.secondary">
        <UserLabel
          showIcon
          id={creator.id}
          user={{
            name: creator.name,
            surname: creator.surname,
            email: creator.email,
          }}
        />
      </Typography>
      <Typography variant="caption" color="text.secondary">
        ·
      </Typography>
    </>
  );
}
